<template>
  <div>
    <v-dialog v-model="dialog" eager persistent scrollable max-width="500">
      <v-form ref="SkillAssessBatchForm" @submit.prevent>
        <v-card>
          <v-card-title class="d-flex align-center">
            <span>{{ action == "Add" ? "Create New" : "Update" }} Batch</span>
            <v-spacer></v-spacer>
            <v-btn
              icon="mdi-close"
              variant="text"
              color="white"
              @click="closeD()"
            >
            </v-btn>
          </v-card-title>

          <v-card-text style="max-height: 900px" class="">
            <v-container class="pa-5">
              <v-row>
                <v-col cols="12">
                  <v-text-field
                    v-model="name"
                    :rules="[formRules.required]"
                    label="Batch Name"
                    :color="$vuetify.theme.themes.light.inputColor"
                    variant="outlined"
                    density="compact"
                  ></v-text-field>
                </v-col>

                <v-col cols="12">
                  <v-text-field
                    v-model="year"
                    :rules="[formRules.required, formRules.isValidYear]"
                    label="Year"
                    :color="$vuetify.theme.themes.light.inputColor"
                    variant="outlined"
                    density="compact"
                  ></v-text-field>
                </v-col>
              </v-row>
            </v-container>
          </v-card-text>
          <v-divider></v-divider>

          <v-card-actions class="pa-2 mr-4">
            <v-spacer></v-spacer>
            <v-btn color="red" outlined @click="closeD()">
              <v-icon>mdi-close-circle-outline</v-icon>
              Cancel
            </v-btn>
            <v-btn
              :color="$vuetify.theme.themes.light.submitBtnsGreen"
              class="white--text"
              density="comfortable"
              variant="flat"
              :disabled="btnLoading"
              :loading="btnLoading"
              @click="save()"
            >
              <v-icon>mdi-check-circle</v-icon>
              {{ action == "Add" ? "Add" : "Update" }}
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-form>
    </v-dialog>

    <fade-away-message-component
      displayType="default"
      v-model="fadeAwayMessage.show"
      :message="fadeAwayMessage.message"
      :header="fadeAwayMessage.header"
      :type="fadeAwayMessage.type"
    ></fade-away-message-component>
  </div>
</template>

<script>
import eventBus from "@/eventBus";
export default {
  props: {
    data: Object,
    action: String,
    programs: Array,
    batchToAdd: Number,
  },
  data() {
    return {
      dialog: false,
      name: null,
      year: null,
      fadeAwayMessage: {
        show: false,
        type: "success",
        header: "Successfully Added!",
        message: "",
        top: 10,
      },
      fileLoaded: false,
      btnLoading: false,
    };
  },
  watch: {
    data: {
      handler(data) {
        this.dialog = true;

        this.initialize();
        this.$refs.SkillAssessBatchForm.resetValidation();
        if (data.id) {
          this.name = data.name;
          this.year = data.year;
        } else {
          this.$refs.SkillAssessBatchForm.reset();
          this.$refs.SkillAssessBatchForm.resetValidation();
        }
      },
      deep: true,
    },
  },
  computed: {},
  methods: {
    initialize() {},

    async save() {
      let formValid = await this.$refs.SkillAssessBatchForm.validate();

      if (formValid.valid) {
        let url = "";
        if (this.batchToAdd == 1) {
          url = "/skill-assessement/add-batch";
        } else if (this.batchToAdd == 2) {
          url = "/student/add-batch";
        }
        this.axiosCall(url, "POST", {
          name: this.name,
          year: this.year,
        }).then((res) => {
          if (res.data.status == 201) {
            this.fadeAwayMessage.show = true;
            this.fadeAwayMessage.type = "success";
            this.fadeAwayMessage.message = res.data.msg;
            this.fadeAwayMessage.header = "System Message";
            this.btnLoading = false;
            this.closeD();
          } else {
            this.btnLoading = false;
            this.fadeAwayMessage.show = true;
            this.fadeAwayMessage.type = "error";
            this.fadeAwayMessage.message = res.data.msg;
            this.fadeAwayMessage.header = "System Message";
          }
        });
      }
    },

    changeTab(tab) {
      this.activeTab = tab;
      this.tab = tab.program_id;
      this.initialize();
    },

    async save_file() {
      let valid = await this.$refs.addFileRef.validate();
      if (valid.valid) {
        this.addFileDialog = false;
      }
    },

    // UpdateInfo() {
    //   let data = {
    //     fname: this.fname,
    //     mname: this.mname,
    //     lname: this.lname,
    //   };
    //   this.axiosCall(
    //     "/user-details/updateUserInfo/" +
    //       this.data.id +
    //       "/" +
    //       JSON.stringify(data),
    //     "POST",
    //     data,
    //   ).then((res) => {
    //     if (res.data.status == 200) {
    //       this.fadeAwayMessage.show = true;
    //       this.fadeAwayMessage.type = "success";
    //       this.fadeAwayMessage.message = res.data.message;
    //       this.fadeAwayMessage.header = "System Message";
    //       this.closeD();
    //       this.refresh();
    //     } else {
    //       this.isLoading = false;
    //       this.fadeAwayMessage.show = true;
    //       this.fadeAwayMessage.type = "error";
    //       this.fadeAwayMessage.message = res.data.message;
    //       this.fadeAwayMessage.header = "System Message";
    //       this.animated = true;
    //     }
    //   });
    // },
    closeD() {
      eventBus.emit("closeSkillAssessmentBatchDialog", true);
      this.dialog = false;
    },

    getPrograms() {
      this.axiosCall("/program", "GET").then((res) => {
        this.programsList = res.data;
      });
    },

    getOrganizations() {
      this.axiosCall(
        "/organization/selection/" + this.$store.state.user.program_id,
        "GET",
      ).then((res) => {
        this.orgsList = res.data;
        this.orgsList.push({ id: -1, name: "Add New Organization/Agency" });
      });
    },
  },
};
</script>

<style scoped>
.tbl {
  width: 100%;
  border-collapse: collapse;
}
</style>
